export function currencyParser(item: any, prefix = '') {
  if (item === undefined) {
    return '';
  }

  prefix = prefix ? ' ' + prefix : '';

  const fixed = Math.abs(item % 1) > 0 ? 2 : 0;
  return (parseFloat(item)).toFixed(fixed).replace(/./g, function (c, i, a) {
    return i && c !== '.' && ((a.length - i) % 3 === 0) ? ' ' + c : c;
  }).replace('.', ',') + prefix;
}
